import React from 'react'
import './sidebar-admin.styles.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook, faBriefcase, faBug, faBuilding, faBullhorn, faCity, faCode, faDice, faEnvelope, faGamepad, faList, faMouse, faPieChart, faUsers } from '@fortawesome/free-solid-svg-icons'
import { useLocation, useNavigate } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'

const SidebarAdmin = () => {

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className='admin-side-menu'>
      <div className='admin-menu-items'>
        <div className={`admin-menu-item ${location.pathname.includes('/games') ? 'active' : ''}`} id='games' onClick={() => navigate('/admin/games')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faGamepad} size='lg' />
          Manage Games
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('/orgs') ? 'active' : ''}`} id='orgs' onClick={() => navigate('/admin/orgs')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faCity} size='lg' />
          Manage Organizations
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('/users') ? 'active' : ''}`} id='users' onClick={() => navigate('/admin/users')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faUsers} size='lg' />
          Manage Users
        </div>
        <div
          className={`admin-menu-item ${location.pathname.includes('/content')
              ? 'active'
              : ''
            }`}
          id='content'
          onClick={() => navigate('/admin/content')} >
          <FontAwesomeIcon className='admin-menu-icon' icon={faBriefcase} size='lg' />
          Manage Content
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('/announcements') ? 'active' : ''}`} id='announcements' onClick={() => navigate('/admin/announcements')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faBullhorn} size='lg' />
          Manage Announcements
        </div>
        {/* <div className={`admin-menu-item ${location.pathname.includes('/templategames') ? 'active': ''}`} id='templateGames' onClick={() => navigate('templategames')}>
                    <FontAwesomeIcon className='admin-menu-icon' icon={faDice} size='lg' />
                    Template Games
                </div> */}
        <div className={`admin-menu-item ${location.pathname.includes('/resources') ? 'active' : ''}`} id='resources' onClick={() => navigate('/admin/resources')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faBook} size='lg' />
          Manage Resources
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('/userdata') ? 'active' : ''}`}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faPieChart} size='lg' />
          User Data
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('/messages') ? 'active' : ''}`} id='messages' onClick={() => navigate('/admin/messages')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faEnvelope} size='lg' />
          Contact Messages
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('functions') ? 'active' : ''}`} id='functions' onClick={() => navigate('/admin/functions')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faCode} size='lg' />
          Admin Functions
        </div>
        <div className={`admin-menu-item ${location.pathname.includes('logs') ? 'active' : ''}`} id='logs' onClick={() => navigate('/admin/logs')}>
          <FontAwesomeIcon className='admin-menu-icon' icon={faMouse} size='lg' />
          Activity Logs
        </div>
      </div>
    </div>
  )
}

export default SidebarAdmin